<template>
    <section>
        <div class="row">
            <template v-if="profile && profile.student && profile.student.branchID == 59">
            </template>               
        </div>
        <div class="col-10 offset-1">
            <div class="row">
                <div class="col">
                    <nav aria-label="breadcrumb">
                        <ul class="breadcrumb mt-5">
                            <li class="breadcrumb-item h3 font-weight-bold mb-0">
                                <router-link v-bind:to="{ name: 'tryout/index' }">
                                    Tryout
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                                {{ tryout.name }}
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-auto col-md-8">
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    &nbsp;
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="card-title text-muted mb-0">
                                Nama TO: 
                            </div>
                            <p class="mb-2 text-loading">
                                {{ tryout.name }}
                            </p>
                            <div class="card-title text-muted mb-0">
                                Tanggal TO:
                            </div>
                            <p class="mb-2" v-if="tryout.tryoutOnline && tryout.tryoutOnline.start && tryout.tryoutOnline.end">
                                {{ [tryout.tryoutOnline.start, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY - HH.mm") }} 
                                s/d 
                                {{ [tryout.tryoutOnline.end, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY - HH.mm") }}
                            </p>
                            
                            <!-- Blok Tampilan Tryout Berdasarkan Kelompok (Groups) -->
                            <template v-if="tryout.tryoutGroups && tryout.tryoutGroups.length">
                                <template v-for="tryoutGroup in tryout.tryoutGroups">
                                    <div class="card-title text-muted mb-0" :key="'group-title-' + tryoutGroup.id">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <span v-if="tryoutGroup.groupSubject">
                                                    {{ tryoutGroup.groupSubject.name }} 
                                                    <template v-if="!tryout.isLocked">
                                                        <i class="fa fa-clock-o"></i> {{ $moment.duration(tryoutGroup.duration).asMinutes() }} menit:
                                                    </template>
                                                </span>
                                            </div>
                                            <div class="col-auto ml-auto align-self-center">
                                                <button v-if="tryout.isLocked && Object.keys(times).length && !times[tryoutGroup.id]" type="button" disabled class="btn btn-sm btn-danger px-4 mb-2">
                                                    Terkunci
                                                </button>
                                                <router-link v-else-if="(!tryout.isLocked && (!tryoutGroup.groupAttempts.length || !tryoutGroup.groupAttempts[0].isSubmitted)) || (tryout.isLocked && tryoutGroup.tryoutSubjects.find(tryoutSubject => !tryoutSubject.subjectAttempts.length || !tryoutSubject.subjectAttempts[0].isSubmitted))" v-bind:to="{name: 'tryout/question/view-group', params: {id: tryout.id, tryoutGroupID: tryoutGroup.id}}" class="btn btn-sm btn-danger px-4 mb-2">
                                                    {{ times[tryoutGroup.id] ? times[tryoutGroup.id].remaining.format('HH:mm:ss') : 'Kerjakan' }}
                                                </router-link>
                                                <button v-else type="button" disabled class="btn btn-sm btn-danger px-4 mb-2">
                                                    Selesai
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="mb-1" :key="'group-list-' + tryoutGroup.id">
                                        <ul class="mb-0 pl-3">
                                            <li v-for="tryoutSubject in tryoutGroup.tryoutSubjects" class="mb-1" v-bind:key="tryoutSubject.id">
                                                <div class="row align-items-center">
                                                    <div class="col">
                                                        <span class="mr-2">
                                                            {{ tryoutSubject.subject ? tryoutSubject.subject.name : '' }} 
                                                            - 
                                                            {{ tryoutSubject.totalQuestion }} Soal
                                                        </span>
                                                        <template v-if="tryout.isLocked">
                                                            <i class="fa fa-clock-o"></i> {{ $moment.duration(tryoutSubject.duration).asMinutes() }} menit:
                                                        </template>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </p>
                                </template>
                            </template>
                            
                            <!-- Blok Tampilan Tryout Berdasarkan Mata Pelajaran Langsung (Subjects) -->
                            <template v-else>
                                <div class="card-title text-muted mb-0">
                                    Mata Pelajaran:
                                </div>
                                <p class="mb-2">
                                    <ul class="mb-0 pl-3">
                                        <li v-for="tryoutSubject in tryout.tryoutSubjects" v-bind:key="tryoutSubject.id">
                                            <div class="row align-items-center">
                                                <div class="col">
                                                    <span class="mr-2">
                                                        {{ tryoutSubject.subject ? tryoutSubject.subject.name : '' }}
                                                        {{ tryoutSubject.code }}
                                                        - 
                                                        {{ tryoutSubject.totalQuestion }} Soal
                                                    </span>
                                                    <i class="fa fa-clock-o"></i> {{ $moment.duration(tryoutSubject.duration).asMinutes() }} menit:
                                                </div>
                                                <div class="col-auto ml-auto align-self-center">
                                                    <button v-if="tryout.isLocked && Object.keys(times).length && !times[tryoutSubject.id]" type="button" disabled class="btn btn-sm btn-danger px-4 mb-2">
                                                        Terkunci
                                                    </button>
                                                    <router-link v-else-if="!tryoutSubject.subjectAttempts || !tryoutSubject.subjectAttempts.length || !tryoutSubject.subjectAttempts[0].isSubmitted" v-bind:to="{name: 'tryout/question/view', params: {id: tryout.id, tryoutSubjectID: tryoutSubject.id}}" class="btn btn-sm btn-danger px-4 mb-2">
                                                        {{ times[tryoutSubject.id] ? times[tryoutSubject.id].remaining.format('HH:mm:ss') : 'Kerjakan' }}
                                                    </router-link>
                                                    <button v-else type="button" disabled class="btn btn-sm btn-danger px-4 mb-2">
                                                        Selesai
                                                    </button>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </p>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Password TO -->
        <b-modal v-model="modal.passcode" modal-class="border-0" header-class="background-primary" footer-class="justify-content-center" v-bind:centered="true" v-bind:hide-footer="true" v-bind:no-close-on-backdrop="true" v-bind:no-close-on-esc="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Masukkan Password TO
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="fetchData">
                    <div class="row">
                        <div class="col-12 mb-3 px-5">
                            <input type="text" v-model="form.passcode" class="form-control form-control-sm required" placeholder="Password" required />
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-outline-danger btn-sm px-5">
                                Submit
                            </button>
                            <router-link v-bind:to="{name: 'tryout/index'}" class="btn btn-danger btn-sm px-5 ml-3">
                                Batal
                            </router-link>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>

        <div class="row">
            <div class="col text-center mt-5">
                <Adsense v-bind:data-ad-client="googleAdsClientKey" data-ad-slot="6426122373"></Adsense>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "TryoutView",
        
        computed: mapState(["profile"]),

        data() {
            return {
                tryout: { tryoutGroups: [], tryoutSubjects: [], tryoutOnline: {} },
                times: {},
                student: { user: {}, branch: {}, school: {}, btaGrade: {} },
                startTime: 0,
                googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
                form: { passcode: localStorage.getItem('passcode') },
                modal: {
                    passcode: false
                },
                isDataLoaded: false,
                isTimerReady: false
            };
        },
        watch: {
            times: {
                handler(currentTimes) {
                    // GUARD: Hentikan jika objek times kosong atau timer belum siap
                    if (!currentTimes || Object.keys(currentTimes).length === 0 || !this.isTimerReady || !this.isDataLoaded) {
                        return;
                    }

                    let delay = 1000;
                    setTimeout(() => {
                        requestAnimationFrame(activeTime => {
                            if (document.hidden) {
                                return;
                            }
                            
                            let times = {};
                            let refresh = false;
                            let elapsedTime = activeTime - this.startTime;

                            if (this.tryout.tryoutGroups && this.tryout.tryoutGroups.length) {
                                for (var i = 0; i < this.tryout.tryoutGroups.length; i++) {
                                    let tryoutGroup = this.tryout.tryoutGroups[i];
                                    if (currentTimes[tryoutGroup.id]) {
                                        let tryoutSubject = tryoutGroup.tryoutSubjects.find(tryoutSubject => tryoutSubject.subjectAttempts.length && !tryoutSubject.subjectAttempts[0].isSubmitted);
                                        if ((!this.tryout.isLocked && tryoutGroup.groupAttempts.length && !tryoutGroup.groupAttempts[0].isSubmitted) || tryoutSubject) {
                                            let duration = currentTimes[tryoutGroup.id].duration;
                                            
                                            if (!duration || (duration.asMilliseconds && duration.asMilliseconds() < 10000)) {
                                                continue;
                                            }
                                            
                                            let remaining = duration - elapsedTime;
                                            if (remaining > delay) {
                                                times[tryoutGroup.id] = {
                                                    remaining: this.$moment(remaining).utcOffset(0),
                                                    duration: duration
                                                };
                                            } else {
                                                refresh = true;
                                                console.log('[SUBMIT] Waktu habis untuk group:', tryoutGroup.id);
                                                if (this.tryout.isLocked) {
                                                    if (tryoutSubject) this.submit(tryoutSubject.id);
                                                } else {
                                                    this.submit(tryoutGroup.id);
                                                }
                                            }
                                        }
                                    }
                                }
                            } else if (this.tryout.tryoutSubjects && this.tryout.tryoutSubjects.length) {
                                for (var i = 0; i < this.tryout.tryoutSubjects.length; i++) {
                                    let tryoutSubject = this.tryout.tryoutSubjects[i];
                                    if (tryoutSubject.subjectAttempts && tryoutSubject.subjectAttempts.length && !tryoutSubject.subjectAttempts[0].isSubmitted && currentTimes[tryoutSubject.id]) {
                                        let duration = currentTimes[tryoutSubject.id].duration;
                                        
                                        if (!duration || (duration.asMilliseconds && duration.asMilliseconds() < 10000)) {
                                            continue;
                                        }
                                        
                                        let remaining = duration - elapsedTime;
                                        if (remaining > delay) {
                                            times[tryoutSubject.id] = {
                                                remaining: this.$moment(remaining).utcOffset(0),
                                                duration: duration
                                            };
                                        } else {
                                            refresh = true;
                                            console.log('[SUBMIT] Waktu habis untuk subject:', tryoutSubject.id);
                                            this.submit(tryoutSubject.id);
                                        }
                                    }
                                }
                            }

                            if (refresh) {
                                this.fetchData();
                            } else {
                                this.times = times;
                            }
                        });
                    }, delay);
                },
                deep: true
            },
            tryout(tryout) {
                this.modal.passcode = false;
                if (tryout.passcode) {
                    localStorage.setItem('passcode', tryout.passcode);
                } else {
                    localStorage.removeItem('passcode');
                }
            }
        },
        methods: {
            submit(reference) {
                if (!reference) {
                    return;
                }
                
                if (!this.tryout.isLocked && this.tryout.tryoutGroups && this.tryout.tryoutGroups.length) {
                    this.axios.post(process.env.API_URL + '/group-attempt/submit', { tryoutGroupID: reference })
                        .then(() => console.log('[SUBMIT] Group attempt submitted'))
                        .catch(error => {
                            console.error('[ERROR] Submit group-attempt failed:', error);
                            this.$toastr('error', 'Gagal menyimpan, silakan refresh halaman', 'Error');
                        });
                } else {
                    this.axios.post(process.env.API_URL + '/subject-attempt/submit', { tryoutSubjectID: reference })
                        .then(() => console.log('[SUBMIT] Subject attempt submitted'))
                        .catch(error => {
                            console.error('[ERROR] Submit subject-attempt failed:', error);
                            this.$toastr('error', 'Gagal menyimpan, silakan refresh halaman', 'Error');
                        });
                }
            },
            fetchData() {
                this.isDataLoaded = false;
                this.isTimerReady = false;
                
                this.axios.get(process.env.API_URL + '/tryout/' + this.$route.params.id, {
                    params: this.form,
                    timeout: 30000
                })
                .then(response => {
                    if (response.data && response.data.status) {
                        this.tryout = response.data.data;
                        if (!this.tryout.tryoutOnline) {
                            return this.$router.replace({ name: 'error', params: { code: 404, message: 'Tryout not found' } });
                        } else if (!this.tryout.tryoutOnline.isOpen) {
                            return this.$router.replace({ name: 'tryout/index' });
                        }

                        let times = {};
                        const minDuration = 10000;
                        
                        if (this.tryout.tryoutGroups && this.tryout.tryoutGroups.length) {
                            for (var i = 0; i < this.tryout.tryoutGroups.length; i++) {
                                let tryoutGroup = this.tryout.tryoutGroups[i];
                                if (!this.tryout.isLocked) {
                                    if (tryoutGroup.groupAttempts && tryoutGroup.groupAttempts.length && !tryoutGroup.groupAttempts[0].isSubmitted) {
                                        let timeRemaining = tryoutGroup.groupAttempts[0].timeRemaining;
                                        if (!timeRemaining || timeRemaining === '00:00:00') continue;
                                        
                                        let duration = this.$moment.duration(timeRemaining);
                                        if (duration.asMilliseconds() < minDuration) continue;
                                        
                                        times[tryoutGroup.id] = {
                                            remaining: this.$moment(duration.asMilliseconds()).utcOffset(0),
                                            duration: duration
                                        };
                                    }
                                } else {
                                    let tryoutSubject = tryoutGroup.tryoutSubjects.find(tryoutSubject => tryoutSubject.subjectAttempts.length && !tryoutSubject.subjectAttempts[0].isSubmitted);
                                    if (tryoutSubject) {
                                        let timeRemaining = tryoutSubject.subjectAttempts[0].timeRemaining;
                                        if (!timeRemaining || timeRemaining === '00:00:00') continue;
                                        
                                        let duration = this.$moment.duration(timeRemaining);
                                        if (duration.asMilliseconds() < minDuration) continue;
                                        
                                        times[tryoutGroup.id] = {
                                            remaining: this.$moment(duration.asMilliseconds()).utcOffset(0),
                                            duration: duration
                                        };
                                    }
                                }
                            }
                        } else if (this.tryout.tryoutSubjects && this.tryout.tryoutSubjects.length) {
                            for (var i = 0; i < this.tryout.tryoutSubjects.length; i++) {
                                let tryoutSubject = this.tryout.tryoutSubjects[i];
                                if (tryoutSubject.subjectAttempts && tryoutSubject.subjectAttempts.length && !tryoutSubject.subjectAttempts[0].isSubmitted) {
                                    let timeRemaining = tryoutSubject.subjectAttempts[0].timeRemaining;
                                    if (!timeRemaining || timeRemaining === '00:00:00') continue;
                                    
                                    let duration = this.$moment.duration(timeRemaining);
                                    if (duration.asMilliseconds() < minDuration) continue;
                                    
                                    times[tryoutSubject.id] = {
                                        remaining: this.$moment(duration.asMilliseconds()).utcOffset(0),
                                        duration: duration
                                    };
                                }
                            }
                        }
                        
                        this.isDataLoaded = true;
                        requestAnimationFrame(activeTime => {
                            this.startTime = activeTime;
                            this.isTimerReady = true;
                            this.times = times;
                        });

                        document.title = 'Tryout Online ' + this.tryout.name + ' - ' + process.env.APP_NAME;
                    } else {
                        this.modal.passcode = true;
                        if (this.form.passcode && response.data.errors) {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                        this.form.passcode = '';
                    }
                })
                .catch(error => {
                    console.error('[ERROR] fetchData failed:', error);
                    if (error.code === 'ECONNABORTED') {
                        this.$toastr('error', 'Koneksi timeout, silakan refresh halaman', 'Error');
                    } else {
                        this.$toastr('error', 'Gagal memuat data, silakan refresh halaman', 'Error');
                    }
                });
            }
        },
        created() {
            this.fetchData();
        }
    };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/tryout/View.vue